import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
import { AnyContact } from '../types';
interface BottomDockProps {
  activeContact: AnyContact | null;
  currentIndex: number;
  totalInLane: number;
  isPaused: boolean;
}
export function BottomDock({
  activeContact,
  currentIndex,
  totalInLane,
  isPaused
}: BottomDockProps) {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!isPaused && activeContact) {
      interval = setInterval(() => setSeconds(s => s + 1), 1000);
    }
    return () => clearInterval(interval);
  }, [isPaused, activeContact]);
  useEffect(() => {
    setSeconds(0);
  }, [activeContact?.id]);
  const formatTime = (totalSeconds: number) => {
    const m = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
    const s = (totalSeconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };
  if (!activeContact) return null;
  return <div className="h-16 bg-olympian-surface border-t border-olympian-border flex items-center justify-between px-8 shrink-0 z-30 animate-crossfade" data-id="element-1">
      {/* Left: Contact Info */}
      <div className="flex items-center gap-4" data-id="element-2">
        <div className="w-9 h-9 rounded-full bg-green-500/10 border border-green-500/30 flex items-center justify-center text-green-400 relative" data-id="element-3">
          <div className="absolute inset-0 rounded-full border border-green-400 animate-pulse-slow opacity-40" data-id="element-4" />
          <PhoneIcon className="w-4 h-4" data-id="element-5" />
        </div>
        <div data-id="element-6">
          <div className="text-sm font-bold text-theme" data-id="element-7">
            {activeContact.name}
          </div>
          <div className="text-xs text-olympian-textMuted font-mono" data-id="element-8">
            {activeContact.phone}
          </div>
        </div>
      </div>

      {/* Center: Timer & Waveform */}
      <div className="flex items-center gap-5" data-id="element-9">
        <div className="text-[10px] text-olympian-textMuted font-bold uppercase tracking-widest" data-id="element-10">
          {isPaused ? 'Paused' : 'Working List'}
        </div>
        <span className={`text-xl font-mono font-light tabular-nums ${isPaused ? 'text-olympian-textMuted' : 'text-theme'}`} data-id="element-11">
          {formatTime(seconds)}
        </span>
        {!isPaused && <div className="flex items-center h-6 gap-[2px]" data-id="element-12">
            {Array.from({
          length: 7
        }).map((_, i) => <div key={i} className="waveform-bar" data-id="element-13" />)}
          </div>}
      </div>

      {/* Right: Progress */}
      <span className="text-xs text-olympian-textMuted font-mono tabular-nums" data-id="element-14">
        Call {currentIndex + 1} of {totalInLane}
      </span>
    </div>;
}